import { CommitmentEventList } from '../../../components/Commitment';

export function CommitmentEvents() {
  return <CommitmentEventList />;
}
